import { heroStats, heroHighlights } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full pt-24 pb-12 md:pt-28 md:pb-20 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-primary-50 via-background-50 to-background-50" />
      <div className="absolute top-0 right-0 -z-10 w-[40rem] h-[40rem] max-w-full rounded-full bg-primary-100/50 blur-3xl" />

      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="sm-reveal">
            <span className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-accent-100 text-accent-800 text-xs font-label font-medium">
              <i className="ri-fire-line" />
              电影 · 电视剧 · 动作片 · 科幻片 · 经典老片
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-[1.15]">
              神马影院资源片单，
              <br className="hidden md:block" />
              一眼找到你想看的那部
            </h1>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              本站把电影、电视剧、动作片、科幻片、经典老片等按类型整理成一份份片单，
              并用热度榜、口碑榜和主题合集帮你缩小范围。无论追新剧还是重温老片，
              都能在这里找到对应的资源入口，省下到处搜索的时间。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#featured"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line" />
                浏览热门片单
              </a>
              <a
                href="#collections"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-background-100 text-foreground-800 text-sm font-label font-medium border border-background-200 hover:border-secondary-300 hover:text-secondary-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-bookmark-3-line" />
                查看主题合集
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-5 max-w-2xl">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-xl md:text-2xl font-bold text-primary-700">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 text-xs text-foreground-500 font-label">
                    {stat.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="sm-reveal-slow relative">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200/80 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20artistic%20illustration%20of%20an%20empty%20vintage%20cinema%20hall%20with%20rows%20of%20deep%20red%20velvet%20seats%20and%20a%20glowing%20amber%20projector%20beam%20cutting%20through%20dusty%20air%20rich%20gold%20and%20crimson%20tones%20soft%20film%20grain%20cozy%20nostalgic%20atmosphere%20high%20detail&width=1200&height=900&seq=hero-cinema-hall-01&orientation=landscape"
                alt="温暖的影院放映厅场景，衬托神马影院片单主题"
                title="神马影院 影视片单资源入口"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/45 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3 rounded-md bg-background-50/95 px-4 py-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 shrink-0">
                  <i className="ri-play-fill text-background-50 text-lg" />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-label font-semibold text-foreground-950 truncate">
                    今日精选：星际穿越
                  </p>
                  <p className="text-xs text-foreground-500 font-label truncate">
                    科幻片 · 9.4 分 · 169 分钟
                  </p>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -left-4 hidden sm:flex items-center gap-3 rounded-lg bg-background-50 border border-background-200/80 px-4 py-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-bar-chart-2-line text-xl" />
              </span>
              <div>
                <p className="text-sm font-label font-semibold text-foreground-950">
                  8 类片单
                </p>
                <p className="text-xs text-foreground-500 font-label">按类型成单更省心</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {heroHighlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}